var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 14.1",
    style: {
      enableBackground: "new 0 0 24 14.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#22a873;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12818",
    transform: "translate(-4467.402 -3499.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26774",
    className: "st0",
    d: "M4491,3506.6c-0.2-0.3-5.2-6.5-11.5-6.6h-0.2c-6.3,0.1-11.3,6.3-11.5,6.6l-0.4,0.5l0.4,0.5 c0.2,0.3,5.2,6.5,11.5,6.6h0.2c6.3-0.1,11.3-6.3,11.5-6.6l0.4-0.5L4491,3506.6z M4484.9,3507.1c0,3-2.4,5.4-5.4,5.5h-0.1 c-3,0-5.5-2.4-5.5-5.5c0-3,2.5-5.5,5.5-5.5h0.1C4482.5,3501.6,4484.9,3504.1,4484.9,3507.1L4484.9,3507.1z M4469.5,3507.1 c1.1-1.2,2.3-2.3,3.7-3.2c-1.1,2-1.1,4.5,0,6.5C4471.8,3509.4,4470.6,3508.3,4469.5,3507.1L4469.5,3507.1z M4489.4,3507.1 c-1.1,1.2-2.3,2.3-3.7,3.2c1.1-2,1.1-4.5,0-6.5C4487.1,3504.7,4488.3,3505.8,4489.4,3507.1L4489.4,3507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26775",
    className: "st0",
    d: "M4478.4,3503.8c0.9,0.4,1.3,1.4,0.9,2.2c-0.4,0.9-1.4,1.3-2.2,0.9c-0.4-0.2-0.7-0.5-0.9-0.9 c-0.5,1.8,0.5,3.7,2.3,4.2c1.8,0.5,3.7-0.5,4.2-2.3s-0.5-3.7-2.3-4.2C4479.7,3503.6,4479,3503.6,4478.4,3503.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeActive);
export default __webpack_public_path__ + "static/media/eye-active.5ea88ad5af9db3037c98c3df854a56e8.svg";
export { ForwardRef as ReactComponent };